import Highway from '@dogstudio/highway';
import store from '../util/store';
import PageAnimation from '../animation/PageAnimation';

export default class PageTransition extends Highway.Transition {
  in({from, to, done}) {
    new PageAnimation(from, to, done);
  }

  out({ done }) {
    if (!document.body.classList.contains('locked')) {
      store.lockBody();
    }
    done();
  }
}



// WEBPACK FOOTER //
// ./scripts/navigation/PageTransition.js